import React from "react";

/**
 * Compact silver readiness ring — value 0..100 with a centered % number.
 * Used in the public transparency dashboard cards.
 */
const polar = (cx, cy, r, deg) => {
  const rad = ((deg - 90) * Math.PI) / 180;
  return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
};

const CompactGauge = ({ value = 0, size = 88, testid, label = "READINESS" }) => {
  const v = Math.max(0, Math.min(100, value));
  const cx = 50;
  const cy = 50;
  const r = 38;
  const startDeg = -130;
  const endDeg = 130;
  const sweep = endDeg - startDeg;
  const arcEnd = startDeg + (sweep * v) / 100;
  const [sx, sy] = polar(cx, cy, r, startDeg);
  const [ex, ey] = polar(cx, cy, r, endDeg);
  const [px, py] = polar(cx, cy, r, arcEnd);
  const largeArc = endDeg - startDeg > 180 ? 1 : 0;
  const largeArcFill = arcEnd - startDeg > 180 ? 1 : 0;

  return (
    <svg
      data-testid={testid}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      aria-label={`${label} ${v}%`}
    >
      {/* Track */}
      <path
        d={`M ${sx} ${sy} A ${r} ${r} 0 ${largeArc} 1 ${ex} ${ey}`}
        stroke="#C0C5CE"
        strokeOpacity="0.18"
        strokeWidth="1.2"
      />
      {/* Progress */}
      {v > 0 && (
        <path
          d={`M ${sx} ${sy} A ${r} ${r} 0 ${largeArcFill} 1 ${px} ${py}`}
          stroke="#C0C5CE"
          strokeWidth="1.6"
          strokeLinecap="round"
          style={{ filter: "drop-shadow(0 0 4px rgba(192,197,206,0.5))" }}
        />
      )}
      {/* Centre value */}
      <text
        x="50"
        y="52"
        textAnchor="middle"
        fontFamily="Fraunces, serif"
        fontSize="22"
        fontWeight="300"
        fill="#FFFFFF"
      >
        {Math.round(v)}
      </text>
      <text
        x="50"
        y="68"
        textAnchor="middle"
        fontFamily="Outfit, sans-serif"
        fontSize="6"
        letterSpacing="2"
        fill="#9AA4B2"
      >
        {label}
      </text>
    </svg>
  );
};

export default CompactGauge;
